<script>
export default {
  name: 'DisplayModeToggle',
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      modes: [
        {
          type: 'card',
          icon: 'grid',
          label: 'Card View',
          textKey: 'BRANCHES.INDEX.VIEW.CARDS',
        },
        {
          type: 'table',
          icon: 'table',
          label: 'Table View',
          textKey: 'BRANCHES.INDEX.VIEW.TABLE',
        },
      ],
    };
  },
  methods: {
    setMode(mode) {
      this.$emit('update:modelValue', mode);
    },
  },
};
</script>

<template>
  <div class="flex bg-slate-100 dark:bg-slate-700 rounded-md p-1 mr-2">
    <button
      v-for="mode in modes"
      :key="mode.type"
      @click="setMode(mode.type)"
      :aria-label="mode.label"
      :class="[
        'px-3 py-1 rounded-md transition-colors flex items-center',
        modelValue === mode.type
          ? 'bg-white dark:bg-slate-600 shadow'
          : 'text-slate-500 dark:text-slate-300'
      ]"
    >
      <fluent-icon :icon="mode.icon" class="h-4 w-4" />
      <span class="ml-1 text-sm hidden md:inline">
        {{ $t(mode.textKey) }}
      </span>
    </button>
  </div>
</template>
